import { Component, ChangeDetectionStrategy, OnInit, ChangeDetectorRef } from "@angular/core";
import { AppLogger } from "app-core";
import { Subject, takeUntil } from "rxjs";
import { CacheService, UserService } from "app-service";

@Component({
  selector: 'app-referral',
  templateUrl: './referral.component.html',
  styleUrls: ['./referral.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReferralComponent implements OnInit {
  public ngUnsubscribe = new Subject<void>();
  public isLoggedIn: boolean = false;
  public referralCode: string = '';

  public constructor(
    private readonly _cacheService: CacheService,
    public readonly _cdRef: ChangeDetectorRef,
    private readonly _userService: UserService
  ) {
  }

  public ngOnInit(): void {
    this._isUserLoggedIn();
  }

  private _isUserLoggedIn(): void {
    this.isLoggedIn = !!this._cacheService.getItem('isLoggedIn');

    if (this.isLoggedIn) {
      this._getReferralCode();
    }
  }

  private _getReferralCode(): void {
    this._userService.getReferralCode()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (result: { code: string }) => {
          this.referralCode = result.code;
          this._cdRef.markForCheck();
        },
        error: (err) => {
          AppLogger.Warning(`Logged in state update failed; Error:${err}`);
        },
      });
  }
}
